import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import ActionText from '../../core/ActionText';
import DataDownload from '../../core/DataDownload';
import { globalStyles as styles } from '../../core/style/gstheme';
import TabbedSubmenu from '../../core/TabbedSubmenu.js';
import GenerateTSV from '../../core/TSV/GenerateTSV';
import withGS from '../../core/withGShoc';
import { SKOS_DATATYPE_CONFIGURATION, SKOS_OBJECT_CONFIGURATION } from '../constants';
import workerCode from '../workers/tsv-export.js';

class ConceptExport extends React.Component {

    render() {

        const { id, graph, classes, data, annotations, defaultLang, templateTarget, enableTSV,
            sortProperty, sortNumerically, examples, entitlements } = this.props;

        if (data._notAvailable) return <ActionText offset="30px">Export is not available.</ActionText>;

        let tabs = enableTSV ?
            ["Download Data", "Generate CSV/HTML/TSV/XLSX"]
            :
            ["Download Data"];

        const currentIRI = data.iri && data.iri.length > 0 ?
            data.iri[data.iri.length - 1]
            :
            data.id;

        return (
            <ProjectConsumer>
                {({ skosXL, ontologyProjectAssociation }) => (
                    <div>
                        <Typography paragraph className={classes.mainHeading} style={{ marginTop: 10 }}>Export</Typography>
                        <TabbedSubmenu tabs={tabs}>
                            <div>
                                <Grid container spacing={2}>
                                    {data.narrower && data.narrower.length > 0 &&
                                        <Grid item xs={12} md={6}>
                                            <DataDownload
                                                dataTest="concept-hierarchy-download"
                                                fullHeight
                                                title="Concept Hierarchy"
                                                skosXLoption={skosXL}
                                                annotationOption={annotations}
                                                graph={graph}
                                                resource={id}
                                                exportName="concepthierarchyexport"
                                                message="Includes data for the concept and all narrower concepts." />
                                        </Grid>
                                    }
                                    <Grid item xs={12} md={6}>
                                        <DataDownload
                                            dataTest="concept-download"
                                            fullHeight
                                            title="Concept"
                                            skosXLoption={skosXL}
                                            annotationOption={annotations}
                                            graph={graph}
                                            resource={id}
                                            exportName="conceptexport"
                                            message="Includes data for the concept only." />
                                    </Grid>
                                </Grid>
                            </div>
                            {enableTSV &&
                                <GenerateTSV
                                    ontologyProjectAssociation={ontologyProjectAssociation}
                                    tsvFunction={workerCode}
                                    tsvMode="concept"
                                    entitlements={entitlements}
                                    examples={examples}
                                    graph={graph}
                                    templateTarget={templateTarget}
                                    options={{
                                        labelProp: 'prefLabel',
                                        columns: {
                                            "https://grafsync.graphifi.com/schema/tsv/hierarchy": "Hierarchy",
                                            "https://grafsync.graphifi.com/schema/tsv/IRI": "IRI"
                                        },
                                        sortProperty,
                                        sortNumerically,
                                        datatypeProperties: SKOS_DATATYPE_CONFIGURATION,
                                        objectProperties: Object.assign({}, SKOS_OBJECT_CONFIGURATION, {
                                            "type": {
                                                "displayName": "Class",
                                                "iri": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                                            }
                                        })
                                    }}
                                    defaultLang={defaultLang}
                                    resource={id}
                                    editedIRI={currentIRI}
                                    labelsExportName="concepttreelabel"
                                    exportName="concepttree" />
                            }
                        </TabbedSubmenu>
                    </div>
                )}
            </ProjectConsumer>
        );
    }
}

ConceptExport.defaultProps = {
    skosXL: false,
    enableTSV: false
};

ConceptExport.propTypes = {
    classes: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    entitlements: PropTypes.array.isRequired,
    templateTarget: PropTypes.string,
    enableTSV: PropTypes.bool,
    examples: PropTypes.array,
    sortProperty: PropTypes.string,
    sortNumerically: PropTypes.bool,
    annotations: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(ConceptExport, ["ALL"], null, {}, true));